import * as util from "../lib/util";
import { basicAuthOptions, bearerAuthOptions } from "./util";
import { apiUrl } from "../config";
import axios from "axios";
import cookie from "react-cookies";
import qs from "querystring";

export function login(email) {
	return axios
		.post(`${apiUrl}/learner/login`, qs.stringify({ username: email }), {
			headers: {
				...basicAuthOptions.headers,
				"Content-Type": "application/x-www-form-urlencoded",
			},
		})
		.then(r => r.data);
}

export function register(email, language) {
	const options = { ...basicAuthOptions };
	if (language) {
		options.headers = { ...options.headers, "Accept-Language": language };
	}
	return axios.post(`${apiUrl}/learner/register`, { email }, options).then(r => r.data);
}

export function logout() {
	const refreshToken = cookie.load("WIC_EDTRACKER_LEARNER_REFRESH");
	return axios
		.post(`${apiUrl}/learner/logout`, { refreshToken }, bearerAuthOptions)
		.then(() => {
			util.deleteCookies();
		})
		.catch(err => {
			console.warn(err);
			util.deleteCookies();
		});
}

export function refresh() {
	const refreshToken = cookie.load("WIC_EDTRACKER_LEARNER_REFRESH");
	return axios
		.post(`${apiUrl}/learner/refresh`, { refreshToken }, basicAuthOptions)
		.then(r => r.data);
}



// WEBPACK FOOTER //
// ./src/api/auth.js